<template>
    <div class="flex w-full flex-col items-center gap-8 max-w-3xl">
        <div class="text-center leading-tight">
            <div class="max-w-2xl display-medium text-balance mb-2">
                <span class="gradient-text">Here's what we need from you</span>
            </div>
            <p class="text-valence-grey-750 body md:display-serif max-w-xl mx-auto text-pretty">To unlock Nadia's full potential, there are a few integrations to set up.</p>
        </div>

        <!-- Action cards -->
        <div class="flex flex-col gap-4 w-full">
            <div v-for="item in actionItems" :key="item.title" class="rounded-xl border bg-white p-5 flex items-start gap-4" :class="item.borderClass">
                <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg" :class="item.iconBgClass">
                    <i :class="`bi ${item.icon} text-lg ${item.iconTextClass}`" aria-hidden="true"></i>
                </div>
                <div class="flex-1 min-w-0">
                    <h3 class="text-sm font-semibold text-gray-900 mb-1">{{ item.title }}</h3>
                    <p class="text-sm text-gray-600 leading-relaxed mb-3">{{ item.description }}</p>
                    <div class="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-xs font-medium" :class="item.ctaClasses">
                        <i :class="`bi ${item.ctaIcon} text-sm`" aria-hidden="true"></i>
                        {{ item.cta }}
                    </div>
                </div>
            </div>
        </div>

        <div class="flex items-center gap-4 mt-2">
            <BaseButton theme="tertiary" @click="emit('back')"> <i class="bi bi-arrow-left mr-1" aria-hidden="true"></i> Back </BaseButton>
            <BaseButton theme="primary" class="w-60 leading-6 body-small" @click="emit('start')"> Start my own journey </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";

const emit = defineEmits<{
    back: [];
    start: [];
}>();

const actionItems = [
    {
        title: "Calendar access",
        icon: "bi-calendar-week",
        description: "Connect Google or Outlook calendars to unlock meeting prep, high-stakes radar, and org insights.",
        cta: "Requires IT team approval",
        ctaIcon: "bi-shield-lock",
        ctaClasses: "bg-valence-violet-50 text-valence-violet-800",
        borderClass: "border-valence-violet-200",
        iconBgClass: "bg-valence-violet-50",
        iconTextClass: "text-valence-violet-600",
    },
    {
        title: "Collaboration Profiles",
        icon: "bi-people-fill",
        description: "Enable personality assessments and connection notes so Nadia can coach on team dynamics and 1:1 prep.",
        cta: "Talk to your Engagement Manager",
        ctaIcon: "bi-chat-dots",
        ctaClasses: "bg-valence-light-blue-50 text-valence-light-blue-800",
        borderClass: "border-valence-light-blue-200",
        iconBgClass: "bg-valence-light-blue-50",
        iconTextClass: "text-valence-light-blue-600",
    },
    {
        title: "Organization context",
        icon: "bi-building",
        description: "Share your values, culture docs, and HRIS data so coaching reflects how your organization actually operates.",
        cta: "Talk to your Engagement Manager",
        ctaIcon: "bi-chat-dots",
        ctaClasses: "bg-[#fef5e1] text-valence-gold-800",
        borderClass: "border-[#f9d43f]",
        iconBgClass: "bg-[#fef5e1]",
        iconTextClass: "text-valence-gold-600",
    },
];
</script>
